import { render, staticRenderFns } from "./LoadingDistintaDettaglio.vue?vue&type=template&id=68ad020e"
import script from "./LoadingDistintaDettaglio.vue?vue&type=script&lang=ts"
export * from "./LoadingDistintaDettaglio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ad020e')) {
      api.createRecord('68ad020e', component.options)
    } else {
      api.reload('68ad020e', component.options)
    }
    module.hot.accept("./LoadingDistintaDettaglio.vue?vue&type=template&id=68ad020e", function () {
      api.rerender('68ad020e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingDistintaDettaglio.vue"
export default component.exports